import React, { useEffect, useState } from "react";
import "./NotFound.css"; // move styles into this file if you want

const NotFound = () => {
  const [stars, setStars] = useState([]);

  // Generate stars dynamically (like your JS)
  useEffect(() => {
    const newStars = [];
    for (let i = 0; i < 15; i++) {
      const size = Math.random() * 4 + 2;
      newStars.push({
        id: i,
        size,
        top: Math.random() * 200,
        left: Math.random() * 200,
        delay: Math.random() * 4,
      });
    }
    setStars(newStars);
  }, []);

  const goHome = () => {
    alert("Redirecting to homepage...");
    // In real scenario: window.location.href = "/";
  };

  const goBack = () => {
    window.history.back();
  };

  const handleSearch = () => {
    const searchTerm = document.querySelector(".search-input").value;
    if (searchTerm.trim() !== "") {
      alert(`Searching for: ${searchTerm}`);
      // In real scenario: window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
    }
  };

  return (
    <div className="body-found">
    <div className="found-1">
      <h1 className="error-code">404</h1>
      <h2 className="error-title">Oops! Page Not Found</h2>
      <p className="error-message">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>

      {/* Search Box */}
      <div className="search-box">
        <input
          type="text"
          className="search-input"
          placeholder="Search our website..."
          onKeyPress={(e) => e.key === "Enter" && handleSearch()}
        />
        <button className="search-button" onClick={handleSearch}>
          Search
        </button>
      </div>

      {/* Buttons */}
      <div className="action-buttons">
        <button className="btn btn-primary" onClick={goHome}>
          Go to Homepage
        </button>
        <button className="btn btn-secondary" onClick={goBack}>
          Go Back
        </button>
      </div>

      {/* Astro + Stars */}
      <div className="astro-container">
        <div className="astro"></div>
        <div className="astro-helmet"></div>
        {stars.map((star) => (
          <div
            key={star.id}
            className="star"
            style={{
              width: `${star.size}px`,
              height: `${star.size}px`,
              top: `${star.top}px`,
              left: `${star.left}px`,
              animationDelay: `${star.delay}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Footer */}
      <footer>
        <p>
          © 2023 Your Website. Need help?{" "}
          <a href="#" style={{ color: "#48dbfb", textDecoration: "none" }}>
            Contact support
          </a>
        </p>
      </footer>
    </div>
    </div>
  );
};

export default NotFound;
